import {LitElement, css, html} from 'lit';
import {customElement, state} from 'lit/decorators.js';
import {animate, fadeIn} from '@lit-labs/motion';
import {repeat} from 'lit/directives/repeat.js';
import {ContextConsumer} from '@lit/context';
import {artistContext} from '../context/artist-context.ts';

import './artist-list-item.ts'

@customElement('artist-list')
export class ArtistList extends LitElement {

  @state()
  private items?:any = []

  @state()
  private loading?:boolean = false

  @state()
  private view?:string = 'grid'

  @state()
  private next?:string | null = null


  createRenderRoot() {
    return this;
  }
  connectedCallback() {
    super.connectedCallback()
    new ContextConsumer(this, {
      context: artistContext,
      subscribe: true,
      callback: ({loading,data, view}) => {
        if (data) {
          this.items = data.items
          this.next = data.links?.next
        }
        if (loading != undefined) {
          this.loading = loading
        }
        if (view) {
          this.view = view
        }
      },
    });
  }

  firstUpdated() {
    this.setupIntersectionObserver();
  }

  private setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && this.next && !this.loading) {
          this._onChange(this.next)
        }
      });
    }, options);

    const sentinel = this.querySelector('#sentinel');
    if (sentinel) {
      observer.observe(sentinel);
    }
  }

  private _onChange(apiLink: any) {
    const options = {
      detail: apiLink,
      bubbles: true,
      composed: true
    };
    this.dispatchEvent(new CustomEvent('artistLoadMore', options));
  }

  render() {
      return html`
          ${this.items?.length 
                ? html`
                  <div class="type-${this.view}">
                  ${repeat(
                      this.items, (i) => i, (item:any, i) =>
                          html`
                              <artist-list-item
                                  class="type-${item.type}"
                                  .item="${item}"
                                  ${animate({
                                      keyframeOptions: {
                                          duration: 300, 
                                          delay: (i * 300) / this.items.length,
                                          fill: 'both',
                                      },
                                      properties: ['opacity'],
                                      in: fadeIn
                                  })}>
                              </artist-list-item>
                          `
                  )}
                  </div>
              `
              : html``
          }
          ${this.items?.length === 0 && !this.loading
                  ? html `<div part="no-results" class="no-results"><slot name="no-results">Keine Ergebnisse</slot></div>`
                  : html ``
          }
          <div id="sentinel"></div>
      `
  }

  static styles = css`
      :host {
          display: block;
          scroll-margin-top: 5rem;
      }           
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'artist-list': ArtistList
  }
}
